import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AddpaymodepopupComponent } from '../../generalpopup/addpaymodepopup/addpaymodepopup.component';
import { AddtranspaymodepopupComponent } from '../../generalpopup/addtranspaymodepopup/addtranspaymodepopup.component';
@Component({
  selector: 'app-activitypopup',
  templateUrl: './activitypopup.component.html',
  styleUrls: ['./activitypopup.component.css']
})
export class ActivitypopupComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private datePipe: DatePipe,private productFindService: NgbModal) {
      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
     }

   
  //Save Validation
  submitted: boolean;
  successfully: boolean;
 

  



  activityColl: any = [];


 @Input() trxid:any=0;
 @Input() formname:any="";

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    
    this.fngetActivity();
   
  }


  
  fngetActivity() {
    var data = {
      'trxid': this.trxid,
    'formname':this.formname,
    'modifiedby':this.loginService.fnGetModUserId,
    }
    this.appService.getActivitylogTransaction(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.activityColl = res.json().result;
              console.log(this.activityColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }








 
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
